import Vue from "vue";
import VueRouter from "vue-router";
import NuevoRegistro from "../views/NuevoRegistro.vue";
import Confirmar from "../views/Confirmar.vue";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Profile from "../views/Profile.vue";
import Loading from "../views/Loading.vue";
import Tracking from "../views/Tracking.vue";
import CambioContrasena from "../views/CambioContrasena";
import OlvideContrasena from "../views/OlvideContrasena";
import OlvidePobox from "../views/OlvidePobox";

import store from "../store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/olvide-pobox",
    name: "Olvide PoBox",
    component: OlvidePobox,
    meta: {
      auth: false,
    },
  },
  {
    path: "/olvide-contrasena",
    name: "Olvide Contraseña",
    component: OlvideContrasena,
    meta: {
      auth: false,
    },
  },
  {
    path: "/cambio-contrasena",
    name: "Cambio Contraseña",
    component: CambioContrasena,
    meta: {
      auth: false,
    },
  },
  {
    path: "/",
    name: "Registro",
    component: NuevoRegistro,
    meta: { auth: false },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      auth: true,
    },
  },
  {
    path: "/confirmar",
    name: "Confirmar",
    component: Confirmar,
    meta: { auth: false },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { auth: false }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { auth: true },
  },
  {
    path: "/tracking",
    name: "Tracking",
    component: Tracking,
    meta: { auth: true },
  },
  {
    path: "/loading",
    name: "Cargando",
    component: Loading,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Sarexpress";
  if (to.query.from) {
    next({ query: to.query });
  } else if ((store.state.user && localStorage.getItem("token")) || !to.meta.auth) {
    next();
  } else if (to.meta.auth && !window.localStorage.getItem("token")) {
    next({ path: "/login" });
  } else if (to.meta.auth && window.localStorage.getItem("token")) {
    next({ path: "/loading", query: { from: to.fullPath } });
  } else {
    next();
  }
});
export default router;
